import { SelectOption } from '@components/shared/FormField'
import { PrqGrowthValue } from '@sections/PersonalGroupGrowthSection'

export function personalGroupGrowthPrqGrowthOptions(): SelectOption<PrqGrowthValue>[] {
  const prqGrowthOptions: SelectOption<PrqGrowthValue>[] = [
    { label: 'DROP', value: PrqGrowthValue.DROP },
    { label: 'MAINTAIN', value: PrqGrowthValue.MAINTAIN },
    { label: 'PRQS_1_TO_2', value: PrqGrowthValue.PRQS_1_TO_2 },
    { label: 'PRQS_3_TO_5', value: PrqGrowthValue.PRQS_3_TO_5 },
    { label: 'PRQS_6_PLUS', value: PrqGrowthValue.PRQS_6_PLUS }
  ]

  return prqGrowthOptions
}
